import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2028256b&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028256b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2028256b')) {
      api.createRecord('2028256b', component.options)
    } else {
      api.reload('2028256b', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2028256b&scoped=true", function () {
      api.rerender('2028256b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/identityManager/edit.vue"
export default component.exports